var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-dropdown',_vm._b({attrs:{"placeholder":"Filter by User Role","track-by":"id","label":"label","options":_vm.roleSelection},on:{"on-selected":_vm.onUserRoleSelected,"on-removed":_vm.onUserRoleRemoved}},'app-dropdown',_vm.attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }